(function () {
    'use strict';

    angular.module('app.controllers.overviewCoolingCircuit', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('overviewcoolingcircuit', {
                abstract: true,
                parent: 'device',
                template: '<ui-view/>',
                url: '/OverviewCoolingCircuit'
            });
        }])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('overviewcoolingcircuit.default', {
                parent: 'overviewcoolingcircuit',
                url: '/:menuEntryId',
                templateUrl: 'views/CustomActions/overviewcoolingcircuit.html',
                defaultParams: {menuEntryId: '00000000-0000-0000-0000-000000000000'},
                controller: 'OverviewCoolingCircuitCtrl',
                breadcrumb: {
                    name: function () {
                        return 'NAV_OverviewCoolingCircuit';
                    }
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('scripts/bower_components/fabric.min.js');
                    }]
                }
            });
        }])



        .controller('OverviewCoolingCircuitCtrl', OverviewCoolingCircuitCtrl);

    /* @ngInject */
    function OverviewCoolingCircuitCtrl(
        $scope,
        $state,
        versionMappingService,

        ENUM,
        $interval,
        f_User,

        __MenuEntry,
        $translate,
        viewMenuBarService,

        API,
        $q,
        xCenterConfig,
        $timeout,

        actualDevice,
        $log,
        overviewCircuitService
        ) {

        /* jshint validthis: true */
        var vm = this;
        $scope.vm = vm;
        var stopAnimations = false;
        vm.debug = false && f_User.is('AdminAccess');

        vm.DeviceConfigVersion = actualDevice.ConfigVersion;
        if (vm.DeviceConfigVersion === undefined || vm.DeviceConfigVersion === null || vm.DeviceConfigVersion < 0) {
            vm.DeviceConfigVersion = 1;
        }

        vm.infoBar = {};
        vm.canvas = {};
        vm.canvas.sprites = {};
        var stopLoadTimers = {
            configs: false,
            dpValues: false,
            deviceTypes: false,
            heatpumpStateLastChanged: false
        };

        var canvas = this.__canvas = new fabric.StaticCanvas('canvas', { skipTargetFind:true });
        var Colors = overviewCircuitService.getColors();
        var imgRoot = './images/overview_cooling_circuit/';
        var deviceTypes;
        var hpType;
        var coolingType;
        var ranOnce = false;

        canvas.labels = {};
        canvas.labels.dict = {};

        var sprites = {
            'Pumpen': [
                {
                    id: 'Pumpe1',
                    url: imgRoot + 'Pumpe.png'
                },
                {
                    id: 'Pumpe2',
                    url: imgRoot + 'Pumpe.png'
                },
                {
                    id: 'Pumpe3',
                    url: imgRoot + 'Pumpe.png'
                }
            ],
            'Lufter': {
                id: 'Luefter',
                url: imgRoot + 'Luefter.png'
            },
            'Sammler': {
                id: 'Sammler',
                url: imgRoot + 'Sammler.png'
            },
            'Verdichter': {
                id: 'Verdichter',
                url: imgRoot + 'Verdichter.png'
            }
        };

        canvas.images = {};
        canvas.images.CoolingCircuitBase = { src: imgRoot + 'CoolingCircuit.jpg' };
        canvas.images.CoolingCircuitDefrost = { src: imgRoot + 'CoolingCircuitDefrost.jpg' };
        canvas.images.CoolingCircuitHeating = { src: imgRoot + 'CoolingCircuitHeating.jpg' };
        canvas.images.SollWasserAus = {
            src: imgRoot + 'sollwasser_aus.png',
            left: 175,
            top: 10
        };
        canvas.images.SollWasserHeizen = {
            src: imgRoot + 'sollwasser_heizen.png',
            left: 175,
            top: 10
        };

        var pipes = {};
        pipes.setColors = function(pipesArray, color) {
            overviewCircuitService.pipes.setColors(pipesArray, color);
        };
        pipes.hide = function(pipe) {
            overviewCircuitService.pipes.hide(pipe);
        };
        pipes.show = function(pipe) {
            overviewCircuitService.pipes.show(pipe);
        };

        var arrows = {};


        var DpType = {};
        DpType.Float = overviewCircuitService.createDpType('Float');
        DpType.Int = overviewCircuitService.createDpType('Int');
        DpType.Bool = overviewCircuitService.createDpType('Bool');

        var Position = overviewCircuitService.getPositions();

        var HeatpumpTypes = {};
        function getHeatpumpTypeByValue(value) {
            return getServerEnumByValue(HeatpumpTypes, value);
        }

        var HeatpumpCoolingTypes = {};
        function getHeatpumpCoolingTypeByValue(value) {
            return getServerEnumByValue(HeatpumpCoolingTypes, value);
        }

        var HeatpumpStates = {};
        function getHeatpumpStateByValue(value) {
            return getServerEnumByValue(HeatpumpStates, value);
        }

        let RegulationSubType = {};
        function getRegulationSubTypeByValue(value) {
            return getServerEnumByValue(RegulationSubType, value);
        }

        function getServerEnumByValue(enumDict, value) {
            for (var key in enumDict) {
                if (enumDict.hasOwnProperty(key)
                    && enumDict[key].EnumValueKeyNumber === value) {
                        return enumDict[key];
                }
            }
            $log.warn('No ' + enumDict + ' found!');
        }




        var favoriteObject = {
            favoriteType : 'MenuEntry',
            favoriteObject:
                __MenuEntry.$buildRaw({
                    "$type" : "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "MenuEntryId": '1940d6c8-5461-485b-84e5-9faea74d705b',
                    "DeviceId": actualDevice.DeviceId,
                    'CustomActionName': 'OverviewCoolingCircuit',
                    'DisplayName': $translate.instant('NAV_OverviewCoolingCircuit'),
                    'ImageName': 'kaeltekreis-info',
                    $UI:{}
                })
            };
        viewMenuBarService.setFavorite(favoriteObject);






























        overviewCircuitService.setFabricDefaults();
        overviewCircuitService.initVersionedDatapoints();




        function showImage(image, showOnTop) {
            if (image.obj === undefined) {
                loadImage(image, showOnTop);
            }
            if (image.obj !== undefined) {
                if (canvas.getObjects().indexOf(image.obj) !== 0) {
                    image.obj.moveTo(0);
                }
                image.obj.set({'visible':true});
            }
        }
        function hideImage(image) {
            if (image.obj !== undefined) {
                image.obj.set({'visible':false});
            }
        }
        function loadImage(image, showOnTop) {
            fabric.Image.fromURL(image.src, function (oImg) {
                // oImg.scale(1.2);
                image.obj = oImg;
                canvas.add(oImg);
                if (!showOnTop) {
                    oImg.moveTo(0);
                }
            },
            {
                left: image.left ? image.left : 0,
                top: image.top ? image.top : 0,
                angle: image.angle ? image.angle : 0
            });
        }

        let firstPassDatapoints = {
            EEV_2nd_available: false,
            Aktueller_Überhitzung_Reglungsmodus: undefined
        }

        this.$onInit = function() {
            var api = new API();
            deviceTypes = ENUM.getDeviceTypesByFilter(1);

            var hpEnumsFilter = {
                "FilterConfigurations":
                [
                    { "EnumName": "HeatpumpState", FilterProfile: 1 },
                    { "EnumName": "HeatpumpType", FilterProfile: 1 },
                    { "EnumName": "HeatpumpCoolingType", FilterProfile: 1 },
                    { "EnumName": "RegulationSubType", FilterProfile: 1 }
                ]
            };
            var hpEnumsPromise = api.System.ResolveEnums(hpEnumsFilter).$promise;

            hpEnumsPromise
                .then(function (data) {
                    fillLocalEnum(data[0].Metadata, HeatpumpStates);

                    /* If HeatpumpType enum available */
                    if (Object.keys(data[1].Metadata).length) {
                        fillLocalEnum(data[1].Metadata, HeatpumpTypes);
                    } else {
                        HeatpumpTypes = {
                            "Unknown": {
                                "EnumValueKey": "Unknown",
                                "EnumValueKeyNumber": 0,
                                "DisplayName": "Unknown"
                            },
                            "Water_Water": {
                                "EnumValueKey": "Water_Water",
                                "EnumValueKeyNumber": 1,
                                "DisplayName": "Water_Water"
                            },
                            "Air_Water": {
                                "EnumValueKey": "Air_Water",
                                "EnumValueKeyNumber": 2,
                                "DisplayName": "Air_Water"
                            },
                            "Brine_Water": {
                                "EnumValueKey": "Brine_Water",
                                "EnumValueKeyNumber": 3,
                                "DisplayName": "Brine_Water"
                            }
                        };
                    }

                    /* If HeatpumpCoolingType enum available */
                    if (Object.keys(data[2].Metadata).length) {
                        fillLocalEnum(data[2].Metadata, HeatpumpCoolingTypes);
                    } else {
                        HeatpumpCoolingTypes = {
                            "Unknown": {
                                "EnumValueKey": "Unknown",
                                "EnumValueKeyNumber": 0,
                                "DisplayName": "Unknown"
                            },
                            "Without_Cooling": {
                                "EnumValueKey": "Without_Cooling",
                                "EnumValueKeyNumber": 1,
                                "DisplayName": "Without_Cooling"
                            },
                            "Active_Cooling": {
                                "EnumValueKey": "Active_Cooling",
                                "EnumValueKeyNumber": 2,
                                "DisplayName": "Active_Cooling"
                            },
                            "Passive_Cooling": {
                                "EnumValueKey": "Passive_Cooling",
                                "EnumValueKeyNumber": 3,
                                "DisplayName": "Passive_Cooling"
                            }
                        };
                    }

                    /* If RegulationSubType enum available */
                    if (Object.keys(data[3].Metadata).length) {
                        fillLocalEnum(data[3].Metadata, RegulationSubType);
                    } else {
                        RegulationSubType = {
                            "None": {
                                "EnumValueKey": "None",
                                "EnumValueKeyNumber": 0,
                                "DisplayName": "None"
                            },
                            "SSH": {
                                "EnumValueKey": "SSH",
                                "EnumValueKeyNumber": 1,
                                "DisplayName": "SSH"
                            },
                            "DSH": {
                                "EnumValueKey": "DSH",
                                "EnumValueKeyNumber": 2,
                                "DisplayName": "DSH"
                            },
                            "DLT": {
                                "EnumValueKey": "DLT",
                                "EnumValueKeyNumber": 3,
                                "DisplayName": "DLT"
                            }
                        };
                    }
                    firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus = RegulationSubType.None;

                    canvasInit();
                    activateLoadDeviceTypesInterval();
                    if (vm.DeviceConfigVersion >= 6) {
                        activateHeatpumpStateLastChangedTimer();
                    }

                    loadDeviceTypes().then(function() {
                        activateLoadConfigsTimer();
                        activateLoadDpValuesTimer();
                    });
                });
        };

        function fillLocalEnum(serverEnum, localEnum) {
            for (var itr in serverEnum) {
                if (serverEnum.hasOwnProperty(itr))    {
                    localEnum[serverEnum[itr].EnumValueKey] = serverEnum[itr];
                }
            }
        }

        window.cancelRequestAnimFrame = (function(){
            return  window.cancelAnimationFrame
                    || window.webkitCancelRequestAnimationFrame
                    || window.mozCancelRequestAnimationFrame
                    || window.oCancelRequestAnimationFrame
                    || window.msCancelRequestAnimationFrame
                    || clearTimeout;
        })();



        function canvasInit() {


            fabric.Sprite = fabric.util.createClass(fabric.Image, {
                type: 'sprite',
                spriteIndex: 0,
                initialize: vm.canvas.sprites.initialize,
                createTmpCanvas: vm.canvas.sprites.createTmpCanvas,
                createSpriteImages: vm.canvas.sprites.createSpriteImages,
                createSpriteImage: vm.canvas.sprites.createSpriteImage,
                _render: vm.canvas.sprites._render,
                play: vm.canvas.sprites.play,
                stop: vm.canvas.sprites.stop
            });

            fabric.Sprite.fromURL = function (url, callback, imgOptions, additionalOptions) {
                for (var attrname in additionalOptions) {
                    if (additionalOptions.hasOwnProperty(attrname)) {
                        imgOptions[attrname] = additionalOptions[attrname];
                    }
                }
                fabric.util.loadImage(url, function (img) {
                    callback(new fabric.Sprite(img, imgOptions));
                });
            };

            fabric.Sprite.async = true;
        }


        var request;
        var render = function() {
            canvas.renderAll();
            request = fabric.util.requestAnimFrame(render);
            if(stopAnimations) {
                stopAllRunningAnimations();
                window.cancelRequestAnimFrame(request);
            }
        };

        function isFunction(functionToCheck) {
            var getType = {};
            return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
        }

        function stopAllRunningAnimations() {
            for (var sprite in vm.canvas.sprites) {
                if (vm.canvas.sprites.hasOwnProperty(sprite)
                    && !isFunction(vm.canvas.sprites[sprite])) {
                    vm.canvas.sprites[sprite].stop();
                }
            }
        }
        function removeAllSprites() {
            for (var sprite in vm.canvas.sprites) {
                if (vm.canvas.sprites.hasOwnProperty(sprite)
                    && !isFunction(vm.canvas.sprites[sprite])) {
                    delete vm.canvas.sprites[sprite];
                }
            }
        }

        vm.textObjects = {};
        canvas.labels.setText = function(dp, labelLeft, labelTop, labelWidth) {
            if (dp === undefined || dp === null) { return; }

            if (dp._ScreenValue === undefined) {
                if (deepCompare([dp._Type, DpType.Float])) {
                    dp._ScreenValue = roundToTwoFixedString(dp.Value)
                                        + (dp._Unit !== undefined && dp._Unit !== '' ? ' ' + dp._Unit : '');
                }
                else if (deepCompare([dp._Type, DpType.Int])) {
                    dp._ScreenValue = dp.Value
                                        + (dp._Unit !== undefined && dp._Unit !== '' ? ' ' + dp._Unit : '');
                }
            }

            var backWidth = 78;
            if (labelWidth !== undefined) {
                backWidth = labelWidth;
            } else if (dp._LabelWidth !== undefined) {
                backWidth = dp._LabelWidth;
            }

            if (vm.textObjects[dp.DatapointConfigId] === undefined) {
                var paddingRight = 0;
                if (!dp._IsCentered) {
                    backWidth -= 3;
                    paddingRight = 3;
                }

                vm.textObjects[dp.DatapointConfigId] = {text: dp._ScreenValue, top: labelTop + 2, left: labelLeft, width: backWidth, paddingRight: paddingRight};
                vm.textObjects[dp.DatapointConfigId].textAlign = dp._IsCentered ? 'center' : 'right';
                vm.textObjects[dp.DatapointConfigId].backgroundColor = dp._LabelColor === undefined ? Colors.green.value : dp._LabelColor;
            } else {
                vm.textObjects[dp.DatapointConfigId].text = dp._ScreenValue;
                vm.textObjects[dp.DatapointConfigId].textAlign = dp._IsCentered ? 'center' : 'right';
                vm.textObjects[dp.DatapointConfigId].backgroundColor = dp._LabelColor === undefined ? Colors.green.value : dp._LabelColor;
            }
        };

        canvas.labels.clearText = function(dp) {
            delete vm.textObjects[dp.DatapointConfigId];
        }

        vm.canvas.sprites.initialize = function (element, options) {
            options || (options = {});

            this.spriteWidth = options.spriteWidth;
            this.spriteHeight = options.spriteHeight;
            options.width = this.spriteWidth;
            options.height = this.spriteHeight;

            this.callSuper('initialize', element, options);

            this.createTmpCanvas();
            this.createSpriteImages();
        };

        vm.canvas.sprites.createTmpCanvas = function () {
            this.tmpCanvasEl = fabric.util.createCanvasElement();
            this.tmpCanvasEl.width = this.spriteWidth || this.width;
            this.tmpCanvasEl.height = this.spriteHeight || this.height;
        };

        vm.canvas.sprites.createSpriteImages = function () {
            this.spriteImages = [];

            var steps = this._element.width / this.spriteWidth;
            for (var i = 0; i < steps; i++) {
                this.createSpriteImage(i);
            }
        };

        vm.canvas.sprites.createSpriteImage = function (i) {
            var tmpCtx = this.tmpCanvasEl.getContext('2d');
            tmpCtx.clearRect(0, 0, this.tmpCanvasEl.width, this.tmpCanvasEl.height);
            tmpCtx.drawImage(this._element, -i * this.spriteWidth, 0);

            var dataURL = this.tmpCanvasEl.toDataURL('image/png');
            var tmpImg = fabric.util.createImage();

            tmpImg.src = dataURL;

            this.spriteImages.push(tmpImg);
        };

        vm.canvas.sprites._render = function (ctx) {
            ctx.drawImage(
              this.spriteImages[this.spriteIndex],
              -this.width / 2,
              -this.height / 2
            );
        };


        vm.canvas.sprites.play = function () {
            var _this = this;

            if (_this.isRunning) {
                return;
            } else {
                _this.isRunning = true;
            }
            this.animInterval = $interval(function () {
                _this.spriteIndex++;
                if (_this.spriteIndex === _this.spriteImages.length) {
                    _this.spriteIndex = 0;
                }
            }, 50);
        };

        vm.canvas.sprites.stop = function () {
            var _this = this;
            if (_this.isRunning) {
                _this.isRunning = false;
            }

            $interval.cancel(this.animInterval);
        };

        function createPipe(left, top, length, position, color) {
            return overviewCircuitService.createPipe(left, top, length, position, color, 6);
        }
        function createBridge(left, top, radius, angle, color) {
            return overviewCircuitService.createBridge(left, top, radius, angle, color, 6);
        }
        function createArrow(fromPoint, toPoint) {
            return overviewCircuitService.createArrow(fromPoint, toPoint);
        }




































































        var previousPump = {};
        function loadDeviceTypes() {
            let defer = $q.defer();

            var api = new API();

            var xChangeDynamicDevicesPromise;
            var xChangeCompactDevicesPromise;
            for (var key in deviceTypes) {
                if (deviceTypes.hasOwnProperty(key)) {
                    var value = deviceTypes[key];

                    if (value.EnumValueKey === 'XChangeDynamic') {
                        xChangeDynamicDevicesPromise = api.Device.GetDevicesByType({ 'DeviceType': deviceTypes[key].EnumValueKeyNumber, 'WithDetails': false }).$promise;
                    }
                    else if (value.EnumValueKey === 'XChangeCompact') {
                        xChangeCompactDevicesPromise = api.Device.GetDevicesByType({ 'DeviceType': deviceTypes[key].EnumValueKeyNumber, 'WithDetails': false }).$promise;
                    }
                }
            }

            $q.all([xChangeDynamicDevicesPromise, xChangeCompactDevicesPromise])
                .then(function (data) {
                    vm.pump = overviewCircuitService.extractPump(data, actualDevice);

                    if (angular.equals(previousPump, vm.pump)) {
                        return;
                    }
                    previousPump = angular.copy(vm.pump);

                    stopAllRunningAnimations();
                    removeAllSprites();
                    ranOnce = false;
                    vm.textObjects = {};
                    canvas.clear();

                    canvas.setBackgroundColor(Colors.background.value, canvas.renderAll.bind(canvas), {
                       left: 0,
                       top: 0
                    });

                    $q.all([detectPumpTypePromise(vm.pump), detectCoolingTypePromise(vm.pump)])
                    .then(function(resp) {
                        hpType = resp[0];
                        coolingType = resp[1];

                        if (hpType === HeatpumpTypes.Water_Water
                            && coolingType === HeatpumpCoolingTypes.Active_Cooling) {
                                var notImplementedYetDp = { DatapointConfigId: 'notImplementedYet' };
                                notImplementedYetDp._IsCentered = true;
                                notImplementedYetDp._LabelWidth = 960;
                                notImplementedYetDp._LabelColor = 'orange';
                                notImplementedYetDp._ScreenValue = $translate.instant('CUSTOM_OverviewCoolingCircuit_NotImplementedYet');
                                canvas.labels.setText(notImplementedYetDp, 0, 236);
                                stopLoadTimers.configs = true;
                                stopLoadTimers.dpValues = true;
                                stopLoadTimers.deviceTypes = true;
                                stopLoadTimers.heatpumpStateLastChanged = true;
                                stopAnimations = true;
                                aktivateDebugFunctions();

                                return defer.resolve();
                        }

                        stopAnimations = false;
                        activateCorrectSystem(hpType, coolingType);

                        findWhichDatapointsShouldLoad()
                        .then(() => {
                            prepareDatapoints(hpType, coolingType)
                            .then(function(preparedDatapoints) {
                                vm.dataPoints = preparedDatapoints;
    
                                $q.all([ loadDatapointDataPromise(vm.dataPoints), loadConfigsPromise(vm.dataPoints) ])
                                .then(function(data) {
                                    vm.dpValues = data[0];
                                    vm.dpConfigs = data[1];
    
                                    processData();
    
                                    defer.resolve();
                                });
                            });
                        })
                    });

                });

            return defer.promise;
        }

        function activateLoadDeviceTypesInterval() {
            $timeout(function() {
                if (stopLoadTimers.deviceTypes) {
                    return;
                }
                activateLoadDeviceTypesInterval();
            }, 6000);
        }

        function detectPumpTypePromise(device) {
            var defer = $q.defer();

            if (device.ConfigVersion <= 3) {
                $q.resolve(defer.resolve(HeatpumpTypes.Air_Water));
            } else {
                var dataPoint = [{'DeviceId': device.DeviceId, 'DatapointConfigId': xCenterConfig.datapointsInt.HP_HeatpumpType}];

                var api = new API();
                var readValuesParams = { "DatapointValues": dataPoint, IgnoreErrors: false };
                api.Datapoint.ReadValues(readValuesParams).$promise
                .then(function (resp) {
                    defer.resolve(getHeatpumpTypeByValue(resp[0].Value));
                }, function () {
                    $log.error('Error: Cannot call ReadValues!');
                });
            }

            return defer.promise;
        }

        function detectCoolingTypePromise(device) {
            var defer = $q.defer();

            if (device.ConfigVersion < 4) {
                $q.resolve(defer.resolve(HeatpumpCoolingTypes.Unknown));
            } else {
                var dataPoint = [{'DeviceId': device.DeviceId, 'DatapointConfigId': xCenterConfig.datapointsInt.HP_CoolingType}];

                var api = new API();
                var readValuesParams = { "DatapointValues": dataPoint, IgnoreErrors: false };
                api.Datapoint.ReadValues(readValuesParams).$promise
                .then(function (resp) {
                    defer.resolve(getHeatpumpCoolingTypeByValue(resp[0].Value));
                }, function () {
                    $log.error('Error: Cannot call ReadValues!');
                });
            }

            return defer.promise;
        }

        function activateCorrectSystem(heatpumpType, coolingType) {
            pipes.right = {
                first: [],
                second: [],
                third: [],
                fourth: [],

                botleft: [],
                botright: [],
                topleft: [],
                topright: []
            };
            arrows = {
                pumpe1: {
                    top:[],
                    bottom:[]
                },
                pumpe23: {
                    top:[],
                    bottom:[]
                },
                setColors: function(arrowsArray, color) {
                    overviewCircuitService.arrows.setColors(arrowsArray, color);
                }
            };

            function createSprite(left, top, scale, id) {
                return function (sprite) {
                    vm.canvas.sprites[id] = sprite;
                    sprite.set({
                        originX: 'left',
                        originY: 'top',
                        left: left,
                        top: top
                    })
                    .scale(scale);
                    canvas.add(sprite);
                };
            }

            var imgOptions = {};
            if (heatpumpType === HeatpumpTypes.Unknown
                || heatpumpType === HeatpumpTypes.Air_Water) {



                    fabric.Sprite.fromURL(sprites.Pumpen[0].url, createSprite(737, 83, 1.0, sprites.Pumpen[0].id), deepCopy(imgOptions), {
                        spriteWidth: 82,
                        spriteHeight: 82
                    });
                    fabric.Sprite.fromURL(sprites.Lufter.url, createSprite(680, 289, 1.0, sprites.Lufter.id), deepCopy(imgOptions), {
                        spriteWidth: 195,
                        spriteHeight: 192
                    });
                    fabric.Sprite.fromURL(sprites.Sammler.url, createSprite(438, 215, 1.0, sprites.Sammler.id), deepCopy(imgOptions), {
                        spriteWidth: 83,
                        spriteHeight: 115
                    });
                    fabric.Sprite.fromURL(sprites.Verdichter.url, createSprite(19, 30, 1.0, sprites.Verdichter.id), deepCopy(imgOptions), {
                        spriteWidth: 157,
                        spriteHeight: 149
                    });

            } else if(heatpumpType === HeatpumpTypes.Brine_Water
                || heatpumpType === HeatpumpTypes.Water_Water) {
                    fabric.Sprite.fromURL(sprites.Verdichter.url, createSprite(98, 50, 1.0, sprites.Verdichter.id), deepCopy(imgOptions), {
                        spriteWidth: 157,
                        spriteHeight: 149
                    });
                    fabric.Sprite.fromURL(sprites.Pumpen[0].url, createSprite(405, 65, 1.0, sprites.Pumpen[0].id), deepCopy(imgOptions), {
                        spriteWidth: 82,
                        spriteHeight: 82
                    });
                    fabric.Sprite.fromURL(sprites.Pumpen[1].url, createSprite(405, 344, 1.0, sprites.Pumpen[1].id), deepCopy(imgOptions), {
                        spriteWidth: 82,
                        spriteHeight: 82
                    });
            }


            if (heatpumpType === HeatpumpTypes.Brine_Water) {
                if (coolingType === HeatpumpCoolingTypes.Passive_Cooling) {
                    activateThreeWayVentilMiddleCircuit();

                    arrows.pumpe1.top.push(createArrow(
                        {
                            x: 406 + 35 + 458,
                            y: 11 + 18
                        },
                        {
                            x: 406 + 35 + 458 + 48,
                            y: 11 + 18
                        }
                    ));
                    arrows.pumpe1.bottom.push(createArrow(
                        {
                            x: 406 + 458 + 48,
                            y: 11 + 172
                        },
                        {
                            x: 406 + 458,
                            y: 11 + 172
                        }
                    ));
                    arrows.pumpe23.top.push(createArrow(
                        {
                            x: 406 + 333 + 48,
                            y: 293 + 18
                        },
                        {
                            x: 406 + 333,
                            y: 293 + 18
                        }
                    ));
                    arrows.pumpe23.bottom.push(createArrow(
                        {
                            x: 406 + 35 + 333,
                            y: 293 + 172
                        },
                        {
                            x: 406 + 35 + 333 + 48,
                            y: 293 + 172
                        }
                    ));
                } else {
                    arrows.pumpe1.top.push(createArrow(
                        {
                            x: 381 + 35 + 128,
                            y: 11 + 18
                        },
                        {
                            x: 381 + 35 + 128 + 48,
                            y: 11 + 18
                        }
                    ));
                    arrows.pumpe1.bottom.push(createArrow(
                        {
                            x: 381 + 128 + 48,
                            y: 11 + 172
                        },
                        {
                            x: 381 + 128,
                            y: 11 + 172
                        }
                    ));
                    arrows.pumpe23.top.push(createArrow(
                        {
                            x: 381 + 128 + 48,
                            y: 290 + 18
                        },
                        {
                            x: 381 + 128,
                            y: 290 + 18
                        }
                    ));
                    arrows.pumpe23.bottom.push(createArrow(
                        {
                            x: 381 + 35 + 128,
                            y: 290 + 174
                        },
                        {
                            x: 381 + 35 + 128 + 48,
                            y: 290 + 174
                        }
                    ));

                }
            } else if (heatpumpType === HeatpumpTypes.Water_Water) {
                var pumpe3koerper = {
                    src: imgRoot + 'pumpekoerper.png',
                    top: 289,
                    left: 729
                };
                showImage(pumpe3koerper);
                fabric.Sprite.fromURL(sprites.Pumpen[2].url, createSprite(755, 344, 1.0, sprites.Pumpen[2].id), deepCopy(imgOptions), {
                    spriteWidth: 82,
                    spriteHeight: 82
                });

                if (coolingType === HeatpumpCoolingTypes.Unknown
                    || coolingType === HeatpumpCoolingTypes.Without_Cooling) {

                    pipes.right.third.push(createPipe(499,306,233,Position.Horizontal));
                    pipes.right.third.forEach(function(pipe) { canvas.add(pipe.body); });
                    pipes.right.third.forEach(function(pipe) { canvas.add(pipe.gradient); });

                    pipes.right.fourth.push(createPipe(499,462,233,Position.Horizontal));
                    pipes.right.fourth.forEach(function(pipe) { canvas.add(pipe.body); });
                    pipes.right.fourth.forEach(function(pipe) { canvas.add(pipe.gradient); });

                    arrows.pumpe1.top.push(createArrow(
                        {
                            x: 381 + 35 + 128,
                            y: 11 + 18
                        },
                        {
                            x: 381 + 35 + 128 + 48,
                            y: 11 + 18
                        }
                    ));
                    arrows.pumpe1.bottom.push(createArrow(
                        {
                            x: 381 + 128 + 48,
                            y: 11 + 172
                        },
                        {
                            x: 381 + 128,
                            y: 11 + 172
                        }
                    ));
                    arrows.pumpe23.top.push(createArrow(
                        {
                            x: 406 + 458 + 48,
                            y: 293 + 18
                        },
                        {
                            x: 406 + 458,
                            y: 293 + 18
                        }
                    ));
                    arrows.pumpe23.bottom.push(createArrow(
                        {
                            x: 406 + 35 + 458,
                            y: 293 + 172
                        },
                        {
                            x: 406 + 35 + 458 + 48,
                            y: 293 + 172
                        }
                    ));
                }
                else if (coolingType === HeatpumpCoolingTypes.Passive_Cooling) {
                    activateThreeWayVentilMiddleCircuit();

                    arrows.pumpe1.top.push(createArrow(
                        {
                            x: 406 + 35 + 458,
                            y: 11 + 18
                        },
                        {
                            x: 406 + 35 + 458 + 48,
                            y: 11 + 18
                        }
                    ));
                    arrows.pumpe1.bottom.push(createArrow(
                        {
                            x: 406 + 458 + 48,
                            y: 11 + 172
                        },
                        {
                            x: 406 + 458,
                            y: 11 + 172
                        }
                    ));
                    arrows.pumpe23.top.push(createArrow(
                        {
                            x: 406 + 458 + 48,
                            y: 293 + 18
                        },
                        {
                            x: 406 + 458,
                            y: 293 + 18
                        }
                    ));
                    arrows.pumpe23.bottom.push(createArrow(
                        {
                            x: 406 + 35 + 458,
                            y: 293 + 172
                        },
                        {
                            x: 406 + 35 + 458 + 48,
                            y: 293 + 172
                        }
                    ));
                } else {
                    /* Excluding Active_Cooling, the state is not defined */
                }
            }


            arrows.pumpe1.top.forEach(function(arrow) { canvas.add(arrow); });
            arrows.pumpe1.bottom.forEach(function(arrow) { canvas.add(arrow); });
            arrows.pumpe23.top.forEach(function(arrow) { canvas.add(arrow); });
            arrows.pumpe23.bottom.forEach(function(arrow) { canvas.add(arrow); });
        }

        function activateThreeWayVentilMiddleCircuit() {
            var waermeuebertrager = {
                src: imgRoot + 'waermeuebertrager.png',
                top: 226,
                left: 613
            };
            showImage(waermeuebertrager, true);
            var dreiwegeventilTop = {
                src: imgRoot + 'dreiwegeventil.png',
                top: 171,
                left: 667
            };
            showImage(dreiwegeventilTop, true);
            var dreiwegeventilBottom = {
                src: imgRoot + 'dreiwegeventil.png',
                top: 478,
                left: 657,
                angle: 180
            };
            showImage(dreiwegeventilBottom, true);

            pipes.right.first.push(createPipe(499,25,350,Position.Horizontal));
            pipes.right.first.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.first.forEach(function(pipe) { canvas.add(pipe.gradient); });


            // first non-shared pipes
            pipes.right.second.push(createPipe(680,180,173,Position.Horizontal));

            // add non-shared pipes
            pipes.right.second.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.second.forEach(function(pipe) { canvas.add(pipe.gradient); });
            pipes.right.topleft.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.topleft.forEach(function(pipe) { canvas.add(pipe.gradient); });

            // then shared pipes
            var sharedPipes = [];
            sharedPipes.push(createPipe(499,180,134,Position.Horizontal));
            sharedPipes.push(createPipe(628,180,64,Position.Horizontal));
            sharedPipes.push(createPipe(628,183,46,Position.Vertical));
            pipes.right.second.push(sharedPipes[0]);
            pipes.right.second.push(sharedPipes[1]);
            pipes.right.topleft.push(sharedPipes[2]);

            // merge shared pipes
            sharedPipes.forEach(function(pipe) { canvas.add(pipe.body); });
            sharedPipes.forEach(function(pipe) { canvas.add(pipe.gradient); });








            pipes.right.third.push(createPipe(499,306,120,Position.Horizontal));
            pipes.right.third.push(createBridge(649,329,15,180));
            pipes.right.third.push(createPipe(642,306,37,Position.Horizontal));
            pipes.right.third.push(createBridge(709,329,15,180));
            pipes.right.third.push(createPipe(702,306,29,Position.Horizontal));


            pipes.right.third.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.third.forEach(function(pipe) { canvas.add(pipe.gradient); });


            pipes.right.fourth.push(createPipe(499,462,126,Position.Horizontal));
            pipes.right.fourth.push(createPipe(620,462,74,Position.Horizontal));
            pipes.right.fourth.push(createPipe(689,462,42,Position.Horizontal));
            pipes.right.botright.push(createPipe(688,280,186,Position.Vertical));

            pipes.right.fourth.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.botright.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.fourth.forEach(function(pipe) { canvas.add(pipe.gradient); });
            pipes.right.botright.forEach(function(pipe) { canvas.add(pipe.gradient); });






            pipes.right.botleft.push(createPipe(628,230,214,Position.Vertical));
            pipes.right.botleft.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.botleft.forEach(function(pipe) { canvas.add(pipe.gradient); });

            pipes.right.topright.push(createPipe(689,203,30,Position.Vertical));
            pipes.right.topright.forEach(function(pipe) { canvas.add(pipe.body); });
            pipes.right.topright.forEach(function(pipe) { canvas.add(pipe.gradient); });
        }

        function reduceRequestParams(oldPoints) {
            var newPoints = [];

            for (var point in oldPoints) {
                if (oldPoints.hasOwnProperty(point)) {
                    newPoints.push(
                        {
                            'DatapointConfigId': oldPoints[point].DatapointConfigId,
                            'DeviceId': oldPoints[point].DeviceId
                        }
                    );
                }
            }

            return newPoints;
        }

        function loadDatapointDataPromise(dataPoints) {
            for (var point in dataPoints) {
                if (dataPoints.hasOwnProperty(point)) {
                    dataPoints[point].DeviceId = vm.pump.DeviceId;
                }
            }

            var api = new API();
            var readValuesParams = { "DatapointValues": reduceRequestParams(dataPoints), IgnoreErrors: false };
            return api.Datapoint.ReadValues(readValuesParams).$promise;
        }

        function loadConfigsPromise(dataPoints) {
            var datapointConfigIds = [];
            for (var point2 in dataPoints) {
                if (dataPoints.hasOwnProperty(point2)) {
                    datapointConfigIds.push(dataPoints[point2].DatapointConfigId);
                }
            }
            var getConfigsParams = {
                DeviceType: vm.pump.DeviceType,
                DeviceVersion: vm.pump.SoftwareVersion,
                DatapointConfigIds: datapointConfigIds,
                IgnoreNotExisting: false,
                OptionFilter:undefined
            };
            var api = new API();
            return api.Datapoint.GetConfigs(getConfigsParams).$promise;
        }

        function findWhichDatapointsShouldLoad() {
            const defer = $q.defer();

            if (actualDevice.ConfigVersion >= 6) {
                const api = new API();
                const readValuesParams = {
                    DatapointValues: [
                        {
                            DeviceId: actualDevice.DeviceId,
                            DatapointConfigId: xCenterConfig.datapointsBool.EEV_2nd_available,
                        },
                        {
                            DeviceId: actualDevice.DeviceId,
                            DatapointConfigId: xCenterConfig.datapointsInt.Aktueller_Überhitzung_Reglungsmodus,
                        }
                    ],
                    IgnoreErrors: true,
                };
                api.Datapoint.ReadValues(readValuesParams)
                    .$promise.then((data) => {
                        const ee = data.filter((rv) => rv.DatapointConfigId === xCenterConfig.datapointsBool.EEV_2nd_available);
                        if (ee.length === 0) {
                            firstPassDatapoints.EEV_2nd_available = false;
                        } else {
                            firstPassDatapoints.EEV_2nd_available = ee[0].Value;
                        }
                        
                        const aur = data.filter((rv) => rv.DatapointConfigId === xCenterConfig.datapointsInt.Aktueller_Überhitzung_Reglungsmodus);
                        if (aur.length === 0) {
                            firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus = RegulationSubType.None;
                        } else {
                            firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus = getRegulationSubTypeByValue(aur[0].Value);
                        }
                        
                        defer.resolve();
                    });
            } else {
                defer.resolve();
            }

            return defer.promise;
        }

        function prepareDatapoints(hpType, coolingType) {
            let defer = $q.defer();

            var dataPoints = [];
            let promisses = [];

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_TotalCOP, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AktuelleMotorleistungKW, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_FanAktuelleLeistung, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.Aussentemperatur_gemittelt, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.HP_HeatpumpState, _Type:DpType.Int});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_VerdichterRotorGeschwindigkeitIst, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat['HP_TT14Öltemperatur'], _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AktuellerDiffernzdruck, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_S1SaugTemperatur, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_S3Hochdruck, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_S4HeissgasendTemperatur, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AktuelleVerdampfungsTemperatur, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_S1Saugdruck, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.HPxyz_AktuelleSchritteEEV, _Type:DpType.Int});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat['HP_AktuelleÜberhitzung'], _Type:DpType.Float});

            if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.None
                || firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.SSH ) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat['HP_SollwertÜberhitzung'], _Type:DpType.Float});
            }
            else if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DSH) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat['Aktueller_Sollwert_DSH'], _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat['Aktuelle_DSH-Überhitzung'], _Type:DpType.Float});
            }
            else if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DLT) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat['Aktueller_Sollwert_DLT'], _Type:DpType.Float});
            }

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis, _Type:DpType.Float});
            promisses.push(versionMappingService.recallFunction('RegelsignalPufferladepumpe'));
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis, _Type:DpType.Float});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_EinlasstempGeokreis, _Type:DpType.Float});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AuslasstempGeokreis, _Type:DpType.Float});

            if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_AktuelleKondensationstemperatur, _Type:DpType.Float});
            }

            if (coolingType === HeatpumpCoolingTypes.Passive_Cooling) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_PassivesKuehlenEintrittstemperatur, _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_UmschaltventileKuehlen, _Type:DpType.Bool});
            }

            if (hpType === HeatpumpTypes.Unknown
                || hpType === HeatpumpTypes.Air_Water) {

                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_RegelsignalLuefter, _Type:DpType.Float});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_Luefter, _Type:DpType.Bool});
                    dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_4WegeVentil, _Type:DpType.Bool});

                    if (firstPassDatapoints.EEV_2nd_available === true) {
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.HP_EEV2Steps, _Type:DpType.Int});
                    }

                    promisses.push(versionMappingService.recallFunction('StatusPufferladepumpe'));
            }
            else if (hpType === HeatpumpTypes.Brine_Water) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.TestModeBrunnenPumpe, _Type:DpType.Bool});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.TestModeSolePumpe, _Type:DpType.Bool});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_RegelsignalSolePumpe, _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_DurchflussSoleKreis, _Type:DpType.Float});
            }
            else if (hpType === HeatpumpTypes.Water_Water) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.TestModeBrunnenPumpe, _Type:DpType.Bool});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.TestModeSolePumpe, _Type:DpType.Bool});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_RegelsignalSolePumpe, _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_DurchflussSoleKreis, _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_GrundwasserWaermetauscherEintrittstemperatur, _Type:DpType.Float});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsFloat.HP_GrundwasserWaermetauscherAustrittstemperatur, _Type:DpType.Float});
            }

            $q.all(promisses)
            .then(function(data) {
                data.forEach(function(dpId) {
                    dataPoints.push(dpId());
                });
                defer.resolve(dataPoints);
            });

            return defer.promise;
        }

        function activateLoadConfigsTimer() {
            $timeout(function() {
                if (stopLoadTimers.configs) {
                    return;
                }
                loadConfigsPromise(vm.dataPoints)
                .then(function(resp) {
                    vm.dpConfigs = resp;
                    activateLoadConfigsTimer();
                })
                .catch(function() {
                    $log.error('Unable to fetch datapoint configs!');
                    activateLoadConfigsTimer();
                });
            }, 25000);
        }

        function activateLoadDpValuesTimer() {
            $timeout(function() {
                if (stopLoadTimers.dpValues) {
                    return;
                }
                loadDatapointDataPromise(vm.dataPoints)
                .then(function(resp) {
                    vm.dpValues = resp;
                    activateLoadDpValuesTimer();
                    processData();
                })
                .catch(function() {
                    $log.error('Unable to fetch datapoint values!');
                    activateLoadDpValuesTimer();
                });
            }, 3000);
        }

        function activateHeatpumpStateLastChangedTimer() {
            if (stopLoadTimers.heatpumpStateLastChanged) {
                return;
            }
            const api = new API();
            const readValuesParams = {
                DatapointValues: [
                    {
                        DatapointConfigId: xCenterConfig.datapointsDateTime.HeatpumpStateLastChanged,
                        DeviceId: actualDevice.DeviceId,
                    },
                ],
                IgnoreErrors: true,
            };
            api.Datapoint.ReadValues(readValuesParams)
                .$promise.then((data) => {
                    const now = moment.utc();
                    const last = moment.utc(data[0].Value);
                    const diff = now.diff(last, true);
                    const dur = moment.duration(diff);
                    vm.infoBar.HeatpumpStateLastChanged = dur.hours() + ":" + (dur.minutes() >= 0 && dur.minutes() <= 9 ? '0' : '') + dur.minutes();
                    setTimeout(activateHeatpumpStateLastChangedTimer, 60000);
                })
                .catch(() => {
                    $log.error("Unable to fetch HeatpumpStateLastChanged!");
                    setTimeout(activateHeatpumpStateLastChangedTimer, 60000);
                });
        }

        function processData() {
            vm.updatedData = overviewCircuitService.updateDpValues(vm.dpValues, vm.dpConfigs, vm.dataPoints);
            vm.preparationComplete = true;
        }


        vm.preparationComplete = false;
        $scope.$watch('vm.preparationComplete', function (newValue) {
            vm.preparationComplete = false;
            if (newValue === true) {
                processDpValues(vm.updatedData);
            }
        }, true);

        function startAnimation(animId) {
            if (stopAnimations === undefined) {
                stopAnimations = false;
            }
            if (vm.canvas.sprites[animId] !== undefined) {
                if (canvas.getObjects().indexOf(vm.canvas.sprites[animId]) !== 1) {
                    vm.canvas.sprites[animId].moveTo(1);
                }
                vm.canvas.sprites[animId].play();
            }
        }

        function stopAnimation(animId) {
            if (vm.canvas.sprites[animId] !== undefined) {
                vm.canvas.sprites[animId].stop();
            }
        }


        function processDpValues(data) {
            vm.infoBar.HeatpumpState = getHeatpumpStateByValue(data[xCenterConfig.datapointsInt.HP_HeatpumpState].Value).DisplayName;
            vm.infoBar.HeatpumpStateIcon = getHeatpumpStateByValue(data[xCenterConfig.datapointsInt.HP_HeatpumpState].Value).EnumValueKey;

            var Aussentemperatur_gemitteltDp = data[xCenterConfig.datapointsFloat.Aussentemperatur_gemittelt];
            vm.infoBar.OuterTemperature = roundToTwoFixedString(Aussentemperatur_gemitteltDp.Value) + ' ' + Aussentemperatur_gemitteltDp._Unit;

            let promisses = [];
            promisses.push(versionMappingService.recallFunction('RegelsignalPufferladepumpe'));
            promisses.push(versionMappingService.recallFunction('StatusPufferladepumpe'));

            $q.all(promisses)
            .then(function(getDps) {
                let returnedDatapoints = {};
                getDps.forEach(function(dp) {
                    const func = dp();
                    returnedDatapoints[func.FunctionName] = func.DatapointConfigId;
                });

                continueAfterPromise(data, returnedDatapoints);

                canvas.renderAll();
                overviewCircuitService.deactivateLoading();
            });
        }

        function continueAfterPromise(data, dpIds) {
            var heatpumpStateName = getHeatpumpStateByValue(data[xCenterConfig.datapointsInt.HP_HeatpumpState].Value).EnumValueKey;

            if (data[xCenterConfig.datapointsFloat.HP_TotalCOP] !== undefined) {
                var engineLoadKW = data[xCenterConfig.datapointsFloat.HP_AktuelleMotorleistungKW];
                var fanLoadKW = data[xCenterConfig.datapointsFloat.HP_FanAktuelleLeistung].Value;
                var cop = data[xCenterConfig.datapointsFloat.HP_TotalCOP].Value;

                switch (heatpumpStateName) {
                    case HeatpumpStates.Cooling.EnumValueKey:
                        vm.infoBar.LoadCaption = 'CUSTOM_OverviewCircuits_CoolingLoad';
                        vm.infoBar.Load = roundToTwoFixedString((engineLoadKW.Value + fanLoadKW) * cop, true) + ' ' + engineLoadKW._Unit;
                        vm.infoBar.EffectivityCaption = 'CUSTOM_OverviewCircuits_EER';
                        vm.infoBar.Effectivity = roundToTwoFixedString(cop, true);
                        break;
                    default:
                        vm.infoBar.LoadCaption = 'CUSTOM_OverviewCircuits_HeatingLoad';
                        vm.infoBar.Load = roundToTwoFixedString((engineLoadKW.Value + fanLoadKW) * cop) + ' ' + engineLoadKW._Unit;
                        vm.infoBar.EffectivityCaption = 'CUSTOM_OverviewCircuits_COP';
                        vm.infoBar.Effectivity = roundToTwoFixedString(cop);
                        break;
                }
            } else {
                vm.infoBar.LoadCaption = 'CUSTOM_OverviewCircuits_HeatingLoad';
                vm.infoBar.Load = '-';
                vm.infoBar.EffectivityCaption = 'CUSTOM_OverviewCircuits_COP';
                vm.infoBar.Effectivity = '-';
            }

            if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus !== RegulationSubType.None) {
                showCurrentOverheatingControlMode(hpType);
            }

            if (hpType === HeatpumpTypes.Unknown
                || hpType === HeatpumpTypes.Air_Water) {

                    if (heatpumpStateName === HeatpumpStates.Cooling.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.OnDefrost.EnumValueKey) {
                        showImage(canvas.images.CoolingCircuitDefrost);
                        hideImage(canvas.images.CoolingCircuitHeating);
                        hideImage(canvas.images.CoolingCircuitBase);
                    } else if (heatpumpStateName === HeatpumpStates.OnHeating.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.OnHotWater.EnumValueKey) {
                        hideImage(canvas.images.CoolingCircuitDefrost);
                        showImage(canvas.images.CoolingCircuitHeating);
                        hideImage(canvas.images.CoolingCircuitBase);
                    } else {
                        hideImage(canvas.images.CoolingCircuitDefrost);
                        hideImage(canvas.images.CoolingCircuitHeating);
                        showImage(canvas.images.CoolingCircuitBase);
                    }

                    const heissgasendTemperaturLabelWidth = 86;
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S4HeissgasendTemperatur], 22, 393, heissgasendTemperaturLabelWidth);

                    var verdichterLabelWidth = 82;
                    let HP_VerdichterRotorGeschwindigkeitIstDp = data[xCenterConfig.datapointsFloat.HP_VerdichterRotorGeschwindigkeitIst];
                    canvas.labels.setText(HP_VerdichterRotorGeschwindigkeitIstDp, 188, 47, verdichterLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat['HP_TT14Öltemperatur']], 188, 72, verdichterLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AktuellerDiffernzdruck], 188, 97, verdichterLabelWidth);
                    var HP_StatusKO1VerdichterDp = { DatapointConfigId: 'StatusKO1Verdichter' };
                    prepareOnOffLabel(HP_StatusKO1VerdichterDp, HP_VerdichterRotorGeschwindigkeitIstDp.Value);
                    canvas.labels.setText(HP_StatusKO1VerdichterDp, 188, 122, verdichterLabelWidth);
                    if (HP_VerdichterRotorGeschwindigkeitIstDp.Value > 0) {
                        startAnimation(sprites.Verdichter.id);
                        startAnimation(sprites.Sammler.id);
                    } else {
                        stopAnimation(sprites.Verdichter.id);
                        stopAnimation(sprites.Sammler.id);
                    }

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S1SaugTemperatur], 188, 212, verdichterLabelWidth);

                    var HP_4WegeVentilDp = data[xCenterConfig.datapointsBool.HP_4WegeVentil];
                    prepareOnOffLabel(HP_4WegeVentilDp, HP_4WegeVentilDp.Value);
                    canvas.labels.setText(HP_4WegeVentilDp, 174, 335);

                    var longerLabelWidth = 95;
                    if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AktuelleKondensationstemperatur], 310, 22, longerLabelWidth);
                    }
                    
                    if (firstPassDatapoints.EEV_2nd_available === true) {
                        canvas.labels.setText(data[xCenterConfig.datapointsInt.HP_EEV2Steps], 564, 340, longerLabelWidth);
                    }

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S3Hochdruck], 310, 47, longerLabelWidth);

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AktuelleVerdampfungsTemperatur], 285, 430, longerLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S1Saugdruck], 285, 459, longerLabelWidth);

                    canvas.labels.setText(data[xCenterConfig.datapointsInt.HPxyz_AktuelleSchritteEEV], 437, 340, longerLabelWidth);

                    if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.None
                        || firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.SSH) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['HP_SollwertÜberhitzung']], 437, 429, longerLabelWidth);
                    }
                    else if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DSH) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['Aktueller_Sollwert_DSH']], 22, 261, heissgasendTemperaturLabelWidth);
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['Aktuelle_DSH-Überhitzung']], 22, 286, heissgasendTemperaturLabelWidth);
                    }
                    else if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DLT) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['Aktueller_Sollwert_DLT']], 22, 261, heissgasendTemperaturLabelWidth);
                    }
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat['HP_AktuelleÜberhitzung']], 437, 459, longerLabelWidth);

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempGeokreis], 584, 459);

                    var pumpeLabelWidth = 95;
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis], 840, 67, pumpeLabelWidth);
                    canvas.labels.setText(data[dpIds.RegelsignalPufferladepumpe], 840, 92, pumpeLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis], 840, 117, pumpeLabelWidth);

                    var StatusPufferladepumpeDp = data[dpIds.StatusPufferladepumpe];
                    if (StatusPufferladepumpeDp.Value && data[dpIds.RegelsignalPufferladepumpe].Value > 0) {
                        startAnimation(sprites.Pumpen[0].id);
                        prepareOnOffLabel(StatusPufferladepumpeDp, true);
                    } else {
                        stopAnimation(sprites.Pumpen[0].id);
                        prepareOnOffLabel(StatusPufferladepumpeDp, false);
                    }
                    canvas.labels.setText(StatusPufferladepumpeDp, 840, 142, pumpeLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis], 840, 167, pumpeLabelWidth);

                    var HP_StatusLuefterDp = data[xCenterConfig.datapointsBool.HP_Luefter];
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_RegelsignalLuefter], 863, 261);
                    if (HP_StatusLuefterDp.Value && data[xCenterConfig.datapointsFloat.HP_RegelsignalLuefter].Value > 0) {
                        startAnimation(sprites.Lufter.id);
                        prepareOnOffLabel(HP_StatusLuefterDp, true);
                    } else {
                        stopAnimation(sprites.Lufter.id);
                        prepareOnOffLabel(HP_StatusLuefterDp, false);
                    }
                    canvas.labels.setText(HP_StatusLuefterDp, 776, 261);

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempGeokreis], 863, 459);

            }
            if (hpType === HeatpumpTypes.Brine_Water
                || hpType === HeatpumpTypes.Water_Water) {
                    let verdichterLabelWidth = 82;
                    let HP_VerdichterRotorGeschwindigkeitIstDp = data[xCenterConfig.datapointsFloat.HP_VerdichterRotorGeschwindigkeitIst];
                    canvas.labels.setText(HP_VerdichterRotorGeschwindigkeitIstDp, 9, 76, verdichterLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat['HP_TT14Öltemperatur']], 9, 100, verdichterLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AktuellerDiffernzdruck], 9, 124, verdichterLabelWidth);
                    let HP_StatusKO1VerdichterDp = { DatapointConfigId: 'StatusKO1Verdichter' };
                    prepareOnOffLabel(HP_StatusKO1VerdichterDp, HP_VerdichterRotorGeschwindigkeitIstDp.Value);
                    canvas.labels.setText(HP_StatusKO1VerdichterDp, 9, 148, verdichterLabelWidth);
                    if (HP_VerdichterRotorGeschwindigkeitIstDp.Value > 0) {
                        startAnimation(sprites.Verdichter.id);
                    } else {
                        stopAnimation(sprites.Verdichter.id);
                    }

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S1SaugTemperatur], 89, 210, verdichterLabelWidth);

                    const longerLabelWidth = 95;
                    if (actualDevice.ConfigVersion && actualDevice.ConfigVersion >= 3) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AktuelleKondensationstemperatur], 279, 41, longerLabelWidth);
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S3Hochdruck], 279, 65, longerLabelWidth);
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S4HeissgasendTemperatur], 279, 89, longerLabelWidth);
                    } else {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S3Hochdruck], 279, 41, longerLabelWidth);
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S4HeissgasendTemperatur], 279, 65, longerLabelWidth);
                    }

                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AktuelleVerdampfungsTemperatur], 76, 425, longerLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_S1Saugdruck], 76, 449, longerLabelWidth);

                    canvas.labels.setText(data[xCenterConfig.datapointsInt.HPxyz_AktuelleSchritteEEV], 279, 336, longerLabelWidth);

                    if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.None
                        || firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.SSH) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['HP_SollwertÜberhitzung']], 279, 360, longerLabelWidth);
                    }
                    else if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DSH) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['Aktueller_Sollwert_DSH']], 89, 288, verdichterLabelWidth);
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['Aktuelle_DSH-Überhitzung']], 89, 312, verdichterLabelWidth);
                    }
                    else if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DLT) {
                        canvas.labels.setText(data[xCenterConfig.datapointsFloat['Aktueller_Sollwert_DLT']], 89, 288, verdichterLabelWidth);
                    }
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat['HP_AktuelleÜberhitzung']], 279, 384, longerLabelWidth);

                    let pumpeLabelWidth = 95;
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempLadekreis], 507, 50, pumpeLabelWidth);
                    var RegelsignalPufferladepumpeDp = data[dpIds.RegelsignalPufferladepumpe];
                    canvas.labels.setText(RegelsignalPufferladepumpeDp, 507, 74, pumpeLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HPxyz_DurchflussIstLadekreis], 507, 98, pumpeLabelWidth);

                    var HP_RegelsignalPumpe1OnOffDp = { DatapointConfigId: 'HP_RegelsignalPumpe1OnOff' };
                    if (RegelsignalPufferladepumpeDp.Value > 0) {
                        prepareOnOffLabel(HP_RegelsignalPumpe1OnOffDp, true);
                        startAnimation(sprites.Pumpen[0].id);
                    } else {
                        prepareOnOffLabel(HP_RegelsignalPumpe1OnOffDp, false);
                        stopAnimation(sprites.Pumpen[0].id);
                    }
                    canvas.labels.setText(HP_RegelsignalPumpe1OnOffDp, 507, 122, pumpeLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempLadekreis], 507, 146, pumpeLabelWidth);


                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_EinlasstempGeokreis], 507, 326, pumpeLabelWidth);
                    var HP_RegelsignalSolePumpeDp = data[xCenterConfig.datapointsFloat.HP_RegelsignalSolePumpe];
                    canvas.labels.setText(HP_RegelsignalSolePumpeDp, 507, 350, pumpeLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_DurchflussSoleKreis], 507, 374, pumpeLabelWidth);

                    var TestModeSolePumpeDp = data[xCenterConfig.datapointsBool.TestModeSolePumpe];
                    if (HP_RegelsignalSolePumpeDp.Value > 0 && TestModeSolePumpeDp.Value) {
                        startAnimation(sprites.Pumpen[1].id);
                        prepareOnOffLabel(TestModeSolePumpeDp, true);
                    } else {
                        stopAnimation(sprites.Pumpen[1].id);
                        prepareOnOffLabel(TestModeSolePumpeDp, false);
                    }
                    canvas.labels.setText(TestModeSolePumpeDp, 507, 398, pumpeLabelWidth);
                    canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_AuslasstempGeokreis], 507, 422, pumpeLabelWidth);
            }

            if (hpType === HeatpumpTypes.Brine_Water) {

                if (coolingType === HeatpumpCoolingTypes.Passive_Cooling) {
                    if (heatpumpStateName === HeatpumpStates.OnHeating.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.OnHotWater.EnumValueKey) {
                            passiveCoolingOnHeating();

                    } else if (heatpumpStateName === HeatpumpStates.OnDefrost.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.Cooling.EnumValueKey) {
                            passiveCoolingOnCooling();

                    } else {
                        passiveCoolingOff();
                    }
                    showVentilCoolingHeating(data);
                } else {
                    if (heatpumpStateName === HeatpumpStates.OnHeating.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.OnHotWater.EnumValueKey) {
                        showImage(canvas.images.SollWasserHeizen);
                        hideImage(canvas.images.SollWasserAus);

                        arrows.setColors(arrows.pumpe1.top, Colors.red);
                        arrows.setColors(arrows.pumpe1.bottom, Colors.blue);
                        arrows.setColors(arrows.pumpe23.top, Colors.red);
                        arrows.setColors(arrows.pumpe23.bottom, Colors.blue);
                    } else {
                        showImage(canvas.images.SollWasserAus);
                        hideImage(canvas.images.SollWasserHeizen);

                        arrows.setColors(arrows.pumpe1.top, Colors.white);
                        arrows.setColors(arrows.pumpe1.bottom, Colors.white);
                        arrows.setColors(arrows.pumpe23.top, Colors.white);
                        arrows.setColors(arrows.pumpe23.bottom, Colors.white);
                    }
                }
            } else if (hpType === HeatpumpTypes.Water_Water) {
                if (coolingType === HeatpumpCoolingTypes.Unknown
                    || coolingType === HeatpumpCoolingTypes.Without_Cooling) {

                        if (heatpumpStateName === HeatpumpStates.OnStandby.EnumValueKey) {
                            showImage(canvas.images.SollWasserAus);
                            hideImage(canvas.images.SollWasserHeizen);

                            pipes.setColors(pipes.right.third, Colors.red);
                            pipes.setColors(pipes.right.fourth, Colors.blue);

                            arrows.setColors(arrows.pumpe1.top, Colors.blue);
                            arrows.setColors(arrows.pumpe1.bottom, Colors.red);
                            arrows.setColors(arrows.pumpe23.top, Colors.red);
                            arrows.setColors(arrows.pumpe23.bottom, Colors.blue);

                        } else {
                            showImage(canvas.images.SollWasserAus);
                            hideImage(canvas.images.SollWasserHeizen);

                            pipes.setColors(pipes.right.third, Colors.white);
                            pipes.setColors(pipes.right.fourth, Colors.white);

                            arrows.setColors(arrows.pumpe1.top, Colors.white);
                            arrows.setColors(arrows.pumpe1.bottom, Colors.white);
                            arrows.setColors(arrows.pumpe23.top, Colors.white);
                            arrows.setColors(arrows.pumpe23.bottom, Colors.white);
                        }
                }
                else if (coolingType === HeatpumpCoolingTypes.Passive_Cooling) {
                    if (heatpumpStateName === HeatpumpStates.OnHeating.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.OnHotWater.EnumValueKey) {
                            passiveCoolingOnHeating();

                    } else if (heatpumpStateName === HeatpumpStates.OnDefrost.EnumValueKey
                        || heatpumpStateName === HeatpumpStates.Cooling.EnumValueKey) {
                            passiveCoolingOnCooling();

                    } else {
                        passiveCoolingOff();
                    }

                    showVentilCoolingHeating(data);
                } else {
                    /* Excluding Active_Cooling, the state is not defined */
                }

                let pumpeLabelWidth = 95;
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_GrundwasserWaermetauscherEintrittstemperatur], 857, 326, pumpeLabelWidth);
                var TestModeBrunnenPumpeDp = data[xCenterConfig.datapointsBool.TestModeBrunnenPumpe];
                if (TestModeBrunnenPumpeDp.Value) {
                    startAnimation(sprites.Pumpen[2].id);
                    prepareOnOffLabel(TestModeBrunnenPumpeDp, true);
                } else {
                    stopAnimation(sprites.Pumpen[2].id);
                    prepareOnOffLabel(TestModeBrunnenPumpeDp, false);
                }
                canvas.labels.setText(TestModeBrunnenPumpeDp, 857, 398, pumpeLabelWidth);
                canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_GrundwasserWaermetauscherAustrittstemperatur], 857, 422, pumpeLabelWidth);
            }





            if (!ranOnce) {
                ranOnce = true;
                aktivateDebugFunctions();
                fabric.util.requestAnimFrame(render);
            }
        }

        function passiveCoolingOnHeating() {
            showImage(canvas.images.SollWasserHeizen);
            hideImage(canvas.images.SollWasserAus);

            pipes.setColors(pipes.right.first, Colors.red);
            pipes.setColors(pipes.right.second, Colors.blue);
            pipes.setColors(pipes.right.third, Colors.red);
            pipes.setColors(pipes.right.fourth, Colors.blue);

            pipes.setColors(pipes.right.botleft, Colors.white);
            pipes.setColors(pipes.right.botright, Colors.white);
            pipes.setColors(pipes.right.topleft, Colors.white);
            pipes.setColors(pipes.right.topright, Colors.white);

            arrows.setColors(arrows.pumpe1.top, Colors.red);
            arrows.setColors(arrows.pumpe1.bottom, Colors.blue);
            arrows.setColors(arrows.pumpe23.top, Colors.red);
            arrows.setColors(arrows.pumpe23.bottom, Colors.blue);
        }

        function showVentilCoolingHeating(data) {
            canvas.labels.setText(data[xCenterConfig.datapointsFloat.HP_PassivesKuehlenEintrittstemperatur], 767, 131);
            var HP_UmschaltventileKuehlenDp = data[xCenterConfig.datapointsBool.HP_UmschaltventileKuehlen];
            HP_UmschaltventileKuehlenDp._IsCentered = true;
            if (HP_UmschaltventileKuehlenDp.Value) {
                HP_UmschaltventileKuehlenDp._ScreenValue = $translate.instant('CUSTOM_OverviewCoolingCircuit_UI_Label_VentilCooling');
            } else {
                HP_UmschaltventileKuehlenDp._ScreenValue = $translate.instant('CUSTOM_OverviewCoolingCircuit_UI_Label_VentilHeating');
            }
            canvas.labels.setText(HP_UmschaltventileKuehlenDp, 767, 155);
        }

        function showCurrentOverheatingControlMode(hpType) {
            const longerLabelWidth = 95;
            let AktuellerUberhitzungReglungsmodusDp = {};
            AktuellerUberhitzungReglungsmodusDp._IsCentered = true;
            
            if (firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.SSH) {
                AktuellerUberhitzungReglungsmodusDp._ScreenValue = RegulationSubType.SSH.DisplayName;
            } else if(firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DSH) {
                AktuellerUberhitzungReglungsmodusDp._ScreenValue = RegulationSubType.DSH.DisplayName;
            } else if(firstPassDatapoints.Aktueller_Überhitzung_Reglungsmodus === RegulationSubType.DLT) {
                AktuellerUberhitzungReglungsmodusDp._ScreenValue = RegulationSubType.DLT.DisplayName;
            }

            if (hpType === HeatpumpTypes.Air_Water) {
                canvas.labels.setText(AktuellerUberhitzungReglungsmodusDp, 437, 499, longerLabelWidth);
            } else if (hpType === HeatpumpTypes.Water_Water || hpType === HeatpumpTypes.Brine_Water) {
                canvas.labels.setText(AktuellerUberhitzungReglungsmodusDp, 279, 408, longerLabelWidth);
            }
        }

        function passiveCoolingOnCooling() {
            showImage(canvas.images.SollWasserAus);
            hideImage(canvas.images.SollWasserHeizen);

            pipes.setColors(pipes.right.first, Colors.blue);

            pipes.setColors([ pipes.right.second[0] ], Colors.red);
            pipes.setColors([ pipes.right.second[1] ], Colors.blue);
            pipes.setColors([ pipes.right.second[2] ], Colors.blue);

            pipes.setColors(pipes.right.third, Colors.blue);

            pipes.setColors([ pipes.right.fourth[0] ], Colors.blue);
            pipes.setColors([ pipes.right.fourth[1] ], Colors.red);
            pipes.setColors([ pipes.right.fourth[2] ], Colors.red);

            pipes.setColors(pipes.right.botleft, Colors.blue);
            pipes.setColors(pipes.right.botright, Colors.red);
            pipes.setColors(pipes.right.topleft, Colors.blue);
            pipes.setColors(pipes.right.topright, Colors.red);

            arrows.setColors(arrows.pumpe1.top, Colors.blue);
            arrows.setColors(arrows.pumpe1.bottom, Colors.red);
            arrows.setColors(arrows.pumpe23.top, Colors.blue);
            arrows.setColors(arrows.pumpe23.bottom, Colors.red);
        }

        function passiveCoolingOff() {
            showImage(canvas.images.SollWasserAus);
            hideImage(canvas.images.SollWasserHeizen);

            pipes.setColors(pipes.right.first, Colors.white);
            pipes.setColors(pipes.right.second, Colors.white);
            pipes.setColors(pipes.right.third, Colors.white);
            pipes.setColors(pipes.right.fourth, Colors.white);

            pipes.setColors(pipes.right.botleft, Colors.white);
            pipes.setColors(pipes.right.botright, Colors.white);
            pipes.setColors(pipes.right.topleft, Colors.white);
            pipes.setColors(pipes.right.topright, Colors.white);

            arrows.setColors(arrows.pumpe1.top, Colors.white);
            arrows.setColors(arrows.pumpe1.bottom, Colors.white);
            arrows.setColors(arrows.pumpe23.top, Colors.white);
            arrows.setColors(arrows.pumpe23.bottom, Colors.white);
        }

        function roundToTwoFixedString(num) {
            return (Math.round(((+num) + 0.00001) * 100) / 100 + '').replace(/\./g, ',');
        }

        function prepareOnOffLabel(dp, value, labelWidth) {
            if (dp === undefined) { return; }

            if ((typeof value === 'boolean') && value === true) {
                dp._ScreenValue = $translate.instant('On');
                dp._LabelColor = undefined;
            } else if ((typeof value === 'number') && value > 0) {
                dp._ScreenValue = $translate.instant('On');
                dp._LabelColor = undefined;
            } else {
                dp._ScreenValue = $translate.instant('Off');
                dp._LabelColor = Colors.red.value;
            }

            if (labelWidth !== undefined) {
                dp._LabelWidth = labelWidth;
            }
            dp._IsCentered = true;
        }

        function aktivateDebugFunctions() {
            if (!vm.HeatpumpTypes) {
                vm.HeatpumpTypes = HeatpumpTypes;
            }
            if (!vm.HeatpumpCoolingTypes) {
                vm.HeatpumpCoolingTypes = HeatpumpCoolingTypes;
            }
            if (!vm.HeatpumpStates) {
                vm.HeatpumpStates = HeatpumpStates;
            }
            vm.getHpType = function () {
                return hpType;
            }
            if (!vm.RegulationSubType) {
                vm.RegulationSubType = RegulationSubType;
            }
        }

        vm.setHeatpumpType = function(value) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': '7ecfd672-0dab-4d7b-add0-15b45c831236',
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise
            .then(function() {
                // Such update won't happen with background refresh, so it is ok to reload the page
                $state.reload();
            });
        };

        vm.setHeatpumpCoolingType = function(value) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': '0ed1da37-48a4-47e6-8102-70496177fc57',
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise
            .then(function() {
                // Such update won't happen with background refresh, so it is ok to reload the page
                $state.reload();
            });
        };

        vm.setHeatpumpState = function(value) {
            var api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': '41258683-9b38-4065-80d2-34c9a7e6ec2c',
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise;
        };

        vm.setEVV2Available = function(value) {
            const api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Boolean, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': 'a436a5bb-9c4a-4d12-aae8-31549d43e4b5',
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise;
        }

        vm.setRegulationSubType = function(value) {
            const api = new API();
            var writeValuesParams = {
                'DatapointValues': [{
                    '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Int32, mscorlib]], BMS.Shared',
                    'DeviceId': actualDevice.DeviceId,
                    'DatapointConfigId': xCenterConfig.datapointsInt.Aktueller_Überhitzung_Reglungsmodus,
                    'Value': value
                }]
            };
            return api.Datapoint.WriteValues(writeValuesParams).$promise.then(function() {
                // Such update won't happen with background refresh, so it is ok to reload the page
                $state.reload();
            });
        }

        function deepCopy(oldObject) {
            return JSON.parse(JSON.stringify(oldObject));
        }

        $scope.$on("$destroy", function(){
            stopLoadTimers.configs = true;
            stopLoadTimers.dpValues = true;
            stopLoadTimers.deviceTypes = true;
            stopLoadTimers.heatpumpStateLastChanged = true;
            stopAnimations = true;
        });

    }
})();
